'use client';

import dynamic from 'next/dynamic';

const ContactModal = dynamic(() => import('../../components/ContactModal'), {
  ssr: false,
});

const AIChat = dynamic(() => import('../../page-components/AIChat/AIChat'), {
  ssr: false,
});

const ClientOnlyParts = ({ clientIp }: { clientIp: string; }) => (
  <>
    <ContactModal />
    <AIChat clientIp={clientIp} />
  </>
);

export default ClientOnlyParts;
